import React, {useEffect, useState} from 'react';
import {alertTypes, useAlerts} from '../ui/alert';
import {constants, responseSelector} from '../utils/utils';
import {Content} from '../ui/Content';
import {Row, Col, Box, Button, Pagination} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {Alert} from '../ui/alert';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import axios from 'axios';
import config from '../config';

const baseUrl = config.api.baseUrl;
const key = config.api.key;

export const Sincronizacion = ({history, token}) => {
  const {setTopAlert, topAlert} = useAlerts();
  const [loading, setLoading] = useState(false);

  const requestSincronizar = async () => {
    setLoading(true);
    try {
      const result = await axios.post(
        `${baseUrl}/v1/bd-analisis/copiar`,
        {},
        {
          headers: {
            'x-access-token': process.env.USERS_API_KEY,
          },
        },
      );
      console.log('Resultado de sincronización:', result.data);
      setLoading(false);
      setTopAlert({
        type: alertTypes.success,
        title: 'Éxito',
        text: `Sincronización completada correctamente.`,
      });
    } catch (error) {
      setLoading(false);
      setTopAlert({
        type: alertTypes.error,
        title: 'Error',
        text: `Error al sincronizar: ${
          error?.response?.data?.mensaje ?? 'Error desconocido'
        }`,
      });
    }
  };

  return (
    <Content title="Sincronización de datos" history={history}>
      <Row>
        <Col md="10" mdOffset="1">
          <Box>
            <Alert
              title={null}
              type={alertTypes.info}
              text="La sincronización copiará los datos actuales del sistema a la base de datos de reportería."
              closable={false}
            />
            {topAlert.text && (
              <Alert
                title={topAlert.title}
                type={topAlert.type}
                text={topAlert.text}
                closable={topAlert.closable}
              />
            )}
            <ButtonWithLoading
              text="Sincronizar"
              size="md"
              type="primary"
              submit={requestSincronizar}
              loading={loading}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
